import { Filters } from "./filters";
import { Id } from "./id";

export enum PageTarget {
  WorkflowRoles = "roles_index",
  WorkflowEngagements = "engagements_index",
  WorkflowPlanner = "profiles_index",
  MarketplaceHome = "matching_activities_index",
  MarketplaceInterests = "marketplace_interests_index",
  MarketplaceSaved = "marketplace_saved_index",
  MarketplaceShared = "marketplace_shared_index",
  ActivityFeed = "activities_index",
  BookingModuleProjectsEngagements = "booking_module_engagements_index",
  BookingModuleProjectsRoles = "booking_module_roles_index",
  BookingModuleWorkforce = "booking_module_profiles_index"
}

export type SavedFilter = {
  id: Id;
  name: string;
  target: PageTarget;
  profileId: Id;
  activityId?: Id | null;
} & Filters;
